import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

function getSessionId() {
  try {
    let sid = sessionStorage.getItem("lb-sid");
    if (!sid) {
      sid = typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : "s-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem("lb-sid", sid);
    }
    return sid;
  } catch {
    return "";
  }
}

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const t = setTimeout(() => {
      api
        .post("/track-visit", { path: pathname, session_id: getSessionId() })
        .catch(() => {});
    }, 600);
    return () => clearTimeout(t);
  }, [pathname]);

  return null;
}
